import { getEnvValue } from './helpers/tools';

// Ajax 请求 的 baseURL
export const BASE_URL = '';

// 国际新加坡的 cos 桶
export const COS_BUCKET = 'tig-sg-1258344700';

// cos 域(新加坡)
export const COS_REGION = 'ap-singapore';

export const __PRODUCTION__ = getEnvValue('STAGE') === 'production';

export const __TEST__ = getEnvValue('STAGE') === 'test';

export const __DEV__ = getEnvValue('NODE_ENV') === 'development';

export const LOG_LEVEL = getEnvValue('LOG_LEVEL');
